import React, { useState, useEffect } from "react";
import { InputLabel, Box, Chip, Button, Card, CardContent, TextField, List, ListItem, Paper, useMediaQuery, Modal, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PaymentIcon from "@mui/icons-material/Payment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MenuSection from "./MenuSection";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import estadoDespacho from "../api/estadoDespacho";
import percibePercepciones from "../api/percibePerceciones";
import { FiAlertCircle } from "react-icons/fi";
import generarFacturaJson from "../helpers/generarFacturaJson";
import { validateCUITCUIL, formatCuit, handleCuitChange } from "../helpers/useCuit";
import { limpiarDespachos, handleDeleteRow } from "../helpers/useArticulos";
import { generarFacturaInfo } from "../helpers/generarFacturaInfo"; // Importar el nuevo helper
import AirlineSeatReclineNormalOutlinedIcon from "@mui/icons-material/AirlineSeatReclineNormalOutlined";
import { useProductStore } from "../hooks";
import { useClienteStore } from "../hooks/useClienteStore";
import { validaCantidadAutos } from "../helpers/validacionPromoShell";
import apiErrorHandler from "../helpers/apiErrorHandler"; // Importa el helper
import ValidarLimiteCredito from "../api/validarLimiteCredito";
import FacturacionFlex from "./FacturacionFlex";
import FacturacionMini from "./FacturacionMini";
import RemitoAnticipado from "../api/verificarRemitoAnticipado";

const FacturacionForm = () => {
  const navigate = useNavigate();
  const [total, setTotal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { productos, clearProductos, updateProducto } = useProductStore();
  const { clearClienteState } = useClienteStore();
  const [printingModalOpen, setPrintingModalOpen] = useState(false);
  const [isSuspenderButtonDisabled, setIsSuspenderButtonDisabled] = useState(true);
  const [isPagosButtonDisabled, setIsPagosButtonDisabled] = useState(false);
  const [isEmitirFacturaEnabled, setIsEmitirFacturaEnabled] = useState(false);
  const [isSuspenderRemitoEnabled, setIsSuspenderRemitoEnabled] = useState(true);
  const [cuit, setCuit] = useState("");
  const [cuitError, setCuitError] = useState(false);
  const [condicion, setCondicion] = useState("CONTADO");
  const [clientePercepciones, setClientePercepciones] = useState(0);
  const [cliente, setCliente] = useState(null);
  const limiteAfip = localStorage.getItem("limite");
  const theme = useTheme();
  const isScreenWidthLessThan600 = useMediaQuery(theme.breakpoints.down("sm"));
  const [showWarningModal, setShowWarningModal] = useState(false);
  const puestoActual = JSON.parse(localStorage.getItem("puesto"));
  const [showCreditLimitModal, setShowCreditLimitModal] = useState(false);
  const [showRemitoErrorModal, setShowRemitoErrorModal] = useState(false);
  const [remitoErrorMessage, setRemitoErrorMessage] = useState("");
  const [remitoErrorDetails, setRemitoErrorDetails] = useState("");
  const [isCargandoPercepciones, setIsCargandoPercepciones] = useState(false);
  const [refreshNumero, setRefreshNumero] = useState(false);

  useEffect(() => {
    const clienteStr = localStorage.getItem("cliente");
    if (clienteStr) {
      const clienteData = JSON.parse(clienteStr);
      setCliente(clienteData);
      localStorage.setItem("emiteFacturayRemito", clienteData.emiteFacturayRemito);
    }
  }, []);

  useEffect(() => {
    const tieneProductosConImportePositivo = productos.some(producto => producto.importe > 0);

    if (cliente !== null) {
      if (cliente.condicionVenta.condicionVentaContado === false) {
        // Cliente con cuenta corriente
        setCondicion("CTA. CTE.");
        setIsEmitirFacturaEnabled(tieneProductosConImportePositivo);
        setIsSuspenderButtonDisabled(false);
        setIsPagosButtonDisabled(true);
      } else if (cliente.condicionVenta.condicionVentaContado === true) {
        // Cliente con condición contado
        setCondicion("CONTADO");
        setIsEmitirFacturaEnabled(false);
        setIsSuspenderButtonDisabled(true);
        setIsPagosButtonDisabled(!tieneProductosConImportePositivo);
      }
    } else {
      // Sin cliente seleccionado
      setCondicion("CONTADO");
      setIsEmitirFacturaEnabled(false);
      setIsSuspenderButtonDisabled(true);
      setIsPagosButtonDisabled(!tieneProductosConImportePositivo);
    }
  }, [cliente, productos]);

  useEffect(() => {
    if (cliente && cliente.condicionVenta.condicionVentaContado === false) {
      setIsPagosButtonDisabled(true); // Asegurar que el botón de Pagos esté deshabilitado
    }
  }, [cliente, isPagosButtonDisabled]);

  const handleFacturaElectronica = async () => {
    const facturaInfo = generarFacturaInfo(productos, cliente);
    localStorage.setItem("facturaInfo", JSON.stringify(facturaInfo));
    const completoDatosChofer = localStorage.getItem("completoDatosChofer");

    try {
      // const responseValidarLimite = await ValidarLimiteCredito.verificar();
      //const verificarRemitoAnticipado = await RemitoAnticipado.verificar();

      // if (!responseValidarLimite.puedeRealizarCompra) {
      //   setShowCreditLimitModal(true);
      //   return;
      // }

      // if (verificarRemitoAnticipado.status === 500) {
      //   setRemitoErrorMessage(verificarRemitoAnticipado.message);
      //   setRemitoErrorDetails(verificarRemitoAnticipado.exceptionMessage.replace(/\r\n/g, "<br/>"));
      //   setShowRemitoErrorModal(true);
      //   return; // No continuar si hay error 500
      // }

      localStorage.setItem("vengoDeRemito", true);

      if (cliente.exigeDatosVehiculo) {
        // Si exigeDatosVehiculo es true, verifica si completoDatosChofer es true
        if (completoDatosChofer === "true") {
          navigate("/contrapage/");
        } else {
          navigate("/datoschofer/");
        }
      } else {
        // Si exigeDatosVehiculo es false, va directo a firmar
        navigate("/contrapage/");
      }
    } catch (error) {
      console.error("Error en la validación de crédito o remito anticipado:", error);

      // Si el error proviene de RemitoAnticipado y tiene datos de error 500
      if (error.response?.status === 500) {
        setRemitoErrorMessage(error.response.data.message);
        setRemitoErrorDetails(error.response.data.exceptionMessage.replace(/\r\n/g, "<br/>"));
        setShowRemitoErrorModal(true);
        return; // No continuar si hay error 500
      }
    }
  };

  // Aceptar la condición de SI
  const handleCreditLimitAccept = () => {
    handleSuspenderCTACTE();
    setShowCreditLimitModal(false);
  };

  // Acción de Cancelar
  const handleCreditLimitCancel = () => {
    setShowCreditLimitModal(false);
  };

  const showFormasDePago = () => {
    if (validaCantidadAutos(productos)) {
      setShowWarningModal(true);
      return; // No continua si son más de 4 autitos PROMO SHELL
    }

    const facturaInfo = generarFacturaInfo(productos, cliente);
    localStorage.setItem("facturaInfo", JSON.stringify(facturaInfo));
    const completoDatosChofer = localStorage.getItem("completoDatosChofer");
    console.log(facturaInfo.total);

    if (cliente?.exigeDatosVehiculo) {
      // Si exigeDatosVehiculo es true, verifica si completoDatosChofer es true
      if (completoDatosChofer === "true") {
        navigate("/contrapage/");
      } else {
        navigate("/datoschofer/");
      }
    } else if (limiteAfip < +facturaInfo.total && localStorage.getItem("cliente") === "") {
      // Si exigeDatosVehiculo es false
      setShowModal(true);
    } else {
      navigate("/contrapage");
    }
  };

  const handleBorrarTodo = () => {
    clearProductos();
    clearClienteState();
    setCliente(null);
    localStorage.removeItem("cliente");
    localStorage.removeItem("despachosSeleccionados");
    localStorage.removeItem("facturaInfo");
    localStorage.removeItem("totalProductos");
  };

  useEffect(() => {
    const updateFacturaInfo = async () => {
      setIsCargandoPercepciones(true); // comienza la carga
      setIsPagosButtonDisabled(true); // deshabilitar botón mientras se calcula

      const facturaInfo = generarFacturaInfo(productos, cliente);
      const total = facturaInfo.total;

      const puesto = JSON.parse(localStorage.getItem("puesto"));
      const emiteFacturayRemito = localStorage.getItem("emiteFacturayRemito");

      const facturaJsonLocal = generarFacturaJson(null, puesto, cliente, facturaInfo, parseFloat(total), null, emiteFacturayRemito);

      if (cliente && localStorage.getItem("percepciones") === "true") {
        try {
          const percepciones = await percibePercepciones.getPercibePercepciones(facturaJsonLocal);

          if (typeof percepciones === "number") {
            setClientePercepciones(percepciones.toFixed(2));
            localStorage.setItem("percibePercepciones", percepciones.toFixed(2));

            const totalConPercepciones = parseFloat(total) + percepciones;
            setTotal(totalConPercepciones.toFixed(2));
            localStorage.setItem("totalProductos", totalConPercepciones.toFixed(2));
          } else {
            console.error("Las percepciones no son un número:", percepciones);
          }
        } catch (error) {
          console.error("Error obteniendo percepciones:", error);
          apiErrorHandler(error, { stopFlow: true });
        }
      } else {
        setTotal(total);
        localStorage.setItem("totalProductos", total);
      }

      setIsCargandoPercepciones(false); // termina la carga
    };

    updateFacturaInfo();
  }, [productos, cliente]);

  useEffect(() => {
    if (parseFloat(total) > 0) {
      setIsPagosButtonDisabled(false);
    } else {
      setIsPagosButtonDisabled(true);
    }
  }, [total]);

  const handleSuspenderCTACTE = () => {
    localStorage.setItem("idcondicionVenta", 1);
    setIsPagosButtonDisabled(false);
    setIsEmitirFacturaEnabled(false);
    setCondicion("CONTADO");
    cliente.condicionVenta.condicionVentaContado = true;
    cliente.condicionVenta.descripcionCondicionVenta = "CONTADO";
    cliente.emiteRemito = false;
    cliente.emiteRemitoCabecera = false;
    const clienteStr = JSON.stringify(cliente);
    localStorage.setItem("cliente", clienteStr);
    window.dispatchEvent(new Event("clienteChanged"));
  };

  const handleSuspenderRemito = () => {
    setIsSuspenderRemitoEnabled(false);
    cliente.emiteFacturayRemito = false;
    cliente.emiteRemito = false;
    cliente.emiteRemitoCabecera = false;
    const clienteStr = JSON.stringify(cliente);
    localStorage.setItem("cliente", clienteStr);
    window.dispatchEvent(new Event("clienteChanged"));
    setRefreshNumero(prev => !prev);
  };

  const handleModalCancel = () => {
    setShowModal(false);
  };

  const handleModalAccept = () => {
    if (validateCUITCUIL(cuit.replace(/-/g, ""))) {
      setShowModal(false);
      localStorage.setItem("cuit", cuit);
      localStorage.setItem("IdTipoDocumento", 4);
      navigate("/contrapage");
    } else {
      setCuitError(true);
    }
  };

  const handleGoToSaldos = () => {
    if (cliente) {
      const idCliente = cliente.idCliente;
      const nombreCliente = encodeURIComponent(cliente.razonSocial);
      navigate(`/saldosCtacte/${idCliente}/${nombreCliente}`);
    }
  };

  return (
    <>
      <MenuSection />
      {isScreenWidthLessThan600 ? (
        <FacturacionFlex
          cliente={cliente}
          condicion={condicion}
          isScreenWidthLessThan600={isScreenWidthLessThan600}
          handleSuspenderCTACTE={handleSuspenderCTACTE}
          handleSuspenderRemito={handleSuspenderRemito}
          handleGoToSaldos={handleGoToSaldos}
          isSuspenderRemitoEnabled={isSuspenderRemitoEnabled}
          puestoActual={puestoActual}
          productos={productos}
          handleDeleteRow={handleDeleteRow}
          updateProducto={updateProducto}
          estadoDespacho={estadoDespacho}
          total={total}
          clientePercepciones={clientePercepciones}
          handleDeleteAll={handleBorrarTodo}
          handleFacturaElectronica={handleFacturaElectronica}
          showFormasDePago={showFormasDePago}
          isPagosButtonDisabled={isPagosButtonDisabled}
          isEmitirFacturaEnabled={isEmitirFacturaEnabled}
        />
      ) : (
        <FacturacionMini
          cliente={cliente}
          condicion={condicion}
          handleSuspenderCTACTE={handleSuspenderCTACTE}
          handleSuspenderRemito={handleSuspenderRemito}
          handleGoToSaldos={handleGoToSaldos}
          isSuspenderRemitoEnabled={isSuspenderRemitoEnabled}
          puestoActual={puestoActual}
          theme={theme}
          productos={productos}
          handleDeleteRow={handleDeleteRow}
          updateProducto={updateProducto}
          handleFacturaElectronica={handleFacturaElectronica}
          estadoDespacho={estadoDespacho}
          total={total}
          clientePercepciones={clientePercepciones}
          handleDeleteAll={handleBorrarTodo}
          refreshNumero={refreshNumero}
        />
      )}
      <Modal open={showModal} onClose={handleModalCancel}>
        <Box
          sx={{
            "& .MuiDialog-paper": {
              padding: theme.spacing(1),
              backgroundColor: theme.palette.background.default,
              boxShadow: theme.shadows[5],
              borderRadius: theme.shape.borderRadius,
              display: "flex",
              flexDirection: "column",
            },
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: theme.spacing(2),
            }}
          >
            <FiAlertCircle size={48} color={theme.bandera.colorSecundario} />
          </Box>
          <Typography sx={{ mt: 2, fontSize: 18 }}>Se debe identificar al consumidor final para este importe.</Typography>
          <Typography sx={{ fontSize: 14 }}>Importe máximo: ${limiteAfip}</Typography>
          <Typography sx={{ mt: 2, fontSize: 18 }}>Ingrese un CUIT válido:</Typography>
          <TextField
            label="CUIT"
            value={cuit}
            variant="outlined"
            fullWidth
            sx={{ mb: 4, mt: 2 }}
            onChange={event => handleCuitChange(event, setCuit, setCuitError)}
            error={cuitError}
            helperText={cuitError ? "CUIT debe tener 11 dígitos y ser válido" : ""}
            InputLabelProps={{
              style: { fontSize: "0.85rem", color: "gray" },
            }}
          />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button onClick={handleModalCancel} variant="contained" sx={{ mr: 1, backgroundColor: theme.bandera.colorSecundario }}>
              <Typography variant="body1" style={{ fontSize: "16px", fontWeight: 500 }}>
                Cancelar
              </Typography>
            </Button>
            <Button onClick={handleModalAccept} variant="contained" sx={{ backgroundColor: theme.bandera.colorSecundario }}>
              <Typography variant="body1" style={{ fontSize: "16px", fontWeight: 500 }}>
                Aceptar
              </Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={showWarningModal} onClose={() => setShowWarningModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 320,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              mb: 2,
              fontSize: 20,
              fontWeight: "bold",
              color: theme.palette.text.primary,
            }}
          >
            Límite de autitos excedido
          </Typography>
          <Typography
            sx={{
              mb: 4,
              color: theme.palette.text.secondary,
              fontSize: 16,
            }}
          >
            Se puede facturar un máximo de 4 autitos por transacción
          </Typography>
          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              onClick={() => setShowWarningModal(false)}
              sx={{
                px: 4,
                py: 1,
                backgroundColor: theme.bandera.colorSecundario,
                color: "white",
                fontWeight: "bold",
                borderRadius: "8px",
                fontSize: 14,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
            >
              CERRAR
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={showCreditLimitModal} onClose={handleCreditLimitCancel}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              mb: 2,
              fontSize: 20,
              fontWeight: "bold",
            }}
          >
            Supera el límite de crédito del cliente
          </Typography>
          <Typography
            sx={{
              mb: 4,
              color: theme.palette.text.secondary,
              fontSize: 16,
            }}
          >
            ¿Desea cambiar la condición de venta a contado?
          </Typography>
          <Box display="flex" justifyContent="space-evenly">
            <Button
              variant="contained"
              onClick={handleCreditLimitAccept}
              sx={{
                width: "110px",
                height: "80px",
                backgroundColor: theme.bandera.colorSecundario,
                color: "white",
                fontWeight: "bold",
                borderRadius: "5px",
                fontSize: 16,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
            >
              SI
            </Button>
            <Button
              variant="contained"
              onClick={handleCreditLimitCancel}
              sx={{
                width: "110px",
                height: "80px",
                backgroundColor: theme.palette.grey[400],
                color: "white",
                fontWeight: "bold",
                borderRadius: "5px",
                fontSize: 16,
                ":hover": {
                  backgroundColor: theme.palette.grey[500],
                },
              }}
            >
              NO
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={showRemitoErrorModal} onClose={() => setShowRemitoErrorModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: 20 }}>
            {remitoErrorMessage}
          </Typography>
          <Typography
            sx={{
              mt: 2,
              fontSize: 16,
              whiteSpace: "pre-line",
            }}
            dangerouslySetInnerHTML={{ __html: remitoErrorDetails }}
          />
          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              onClick={() => setShowRemitoErrorModal(false)}
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                color: "white",
                fontWeight: "bold",
                borderRadius: "8px",
                fontSize: 14,
                px: 4,
                py: 1,
              }}
            >
              CERRAR
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default FacturacionForm;
